import { createSlice } from '@reduxjs/toolkit';
import {
  _setIsNewSpedNote,
  _setIsBulkSpedNote,
  _setSingleSpedNote,
  _setSelectedStudents,
} from './spedNotesAction';
import { initialState } from './spedNotesInitialState';

export const spedNotesSlice = createSlice({
  name: 'delta/SPEDNotes',
  initialState,
  reducers: {
    setIsNewSpedNote: _setIsNewSpedNote,
    setSingleSpedNote: _setSingleSpedNote,
    setIsBulkSpedNote: _setIsBulkSpedNote,
    setSelectedStudents: _setSelectedStudents,
  },
});

export const {
  setIsNewSpedNote,
  setSingleSpedNote,
  setIsBulkSpedNote,
  setSelectedStudents,
} = spedNotesSlice.actions;

export default spedNotesSlice.reducer;
